<template>
<div class="GatewayChild">
  <div class="navShow">
    <i><img src="../../../assets/img/setIcon.png" alt=""></i>
    <el-breadcrumb separator=">">
      <template v-if="showChild&&JSON.stringify(tabData) == '{}'">
        <el-breadcrumb-item>
          <span class="deviceJump" @click="jumpDev">设备列表</span>
        </el-breadcrumb-item>
        <template>
          <el-breadcrumb-item>
            <span>子设备列表</span>
          </el-breadcrumb-item>
        </template>
      </template>
    </el-breadcrumb>
    <el-breadcrumb separator=">">
      <template v-if="JSON.stringify(tabData) != '{}'">
        <el-breadcrumb-item>
          <span class="deviceJump" @click="jumpDev">设备列表</span>
        </el-breadcrumb-item>
        <template>
          <el-breadcrumb-item>
            <span class="deviceJumpChild" @click="jumpDevChild">子设备列表</span>
          </el-breadcrumb-item>
        </template>
        <template>
          <el-breadcrumb-item><span>{{devcieIdCode}}</span></el-breadcrumb-item>
        </template>
        <template>
          <el-breadcrumb-item><span>{{tabData.name}}</span></el-breadcrumb-item>
        </template>
      </template>
    </el-breadcrumb>
  </div>
  <div class="devcieContainer" :style="styleObject" v-if="JSON.stringify(tabData) == '{}'">
    <div class="container">
      <div class="query">
        <div class="queryCons">
          <div class="common">
            <el-input placeholder="安装位置" autocomplete="off" v-model="searchText"></el-input>
            <div class="search" @click="serachData">
              <i><img src="../../../assets/img/searchIcon.png" alt=""></i>
            </div>
          </div>
          <el-select class="common" v-model="keyWords.isOnline" placeholder="在线状态" clearable @change="isOnlineChange">
            <el-option label="离线" :value="0"></el-option>
            <el-option label="在线" :value="1"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isAlarm" placeholder="报警状态" clearable @change="isAlarmChange">
            <el-option label="正常" :value="0"></el-option>
            <el-option label="报警中" :value="1"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isFault" placeholder="是否故障" clearable @change="isFaultChange">
            <el-option label="完好" :value="0"></el-option>
            <el-option label="故障" :value="1"></el-option>
          </el-select>
          <!-- <button class="primaryBtn common" @click="serachData">搜索</button> -->
          <!-- <button class="delSome" @click="changeRightCons">
            <i class="imgShow"><img src="../../../assets/img/statistics.png" alt=""></i>
            <span>实时统计</span>
          </button> -->
        </div>
      </div>
      <div class="listsContainer" :style="styleObjectCons">
        <div class="listsLeft">
          <el-scrollbar wrap-class="scrollbar-wrapper" v-loading="tableLoading">
            <ul class="clearfix cardList">
              <li v-for="(dataInfo,index) in dataList" :key="index">
                <card-child @changeCards="changeCards" :info="dataInfo" @clickEven="clickEven"></card-child>
              </li>
            </ul>
          </el-scrollbar>
          <div class="noData" v-if="!(dataList&&dataList.length)&&consShow">
            <img src="../../../assets/img/noData.png" alt="">
            <div class="tip">暂无数据</div>
          </div>
          <div class="cardPage">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.currentPage" :page-sizes="pagination.pageSizes" :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mainContent" :style="styleObject" v-if="JSON.stringify(tabData) != '{}'">
    <div class="tabBox">
      <tab-block @tabToggle="toggleCom" :pageType="pageType" :tabs="tabs"></tab-block>
    </div>
    <div class="main">
      <component :is="component" :deviceChildId="deviceChildId" :typeChild="typeChild" :type="type"></component>
    </div>
  </div>
</div>
</template>

<script>
import TabBlock from '@/components/common/TabBlock'
import BasicInfoChild from '@/views/deviceManagement/gatewayChild/BasicInfoChild'
import DeviceDatasChild from '@/views/deviceManagement/gatewayChild/DeviceDatasChild'
import AlarmRecordChild from '@/views/deviceManagement/gatewayChild/AlarmRecordChild'
import FaultRecordChild from '@/views/deviceManagement/gatewayChild/FaultRecordChild'
import DeviceRightCons from '@/views/deviceManagement/gatewayChild/DeviceRightCons'
import CardChild from '@/views/deviceManagement/gatewayChild/CardChild'
export default {
  name: 'GatewayChild',
  components: {
    TabBlock,
    BasicInfoChild,
    DeviceDatasChild,
    AlarmRecordChild,
    FaultRecordChild,
    CardChild,
    DeviceRightCons
  },
  props: {
    deviceId: {
      type: Number,
      default: () => {
        return null;
      }
    },
    type: {
      type: String,
      default: () => {
        return null;
      }
    }
  },
  data() {
    return {
      searchText: '',
      keyWords: {
        isAlarm: "",
        isFault: "",
        isOnline: ""
      },
      options: [{
        value: '1',
        label: '在线'
      }, {
        value: '0',
        label: '离线'
      }],
      component: '',
      tabs: [{
          name: '基本信息',
          code: 'BasicInfoChild'
        }, {
          name: '设备数据',
          code: 'DeviceDatasChild'
        },
        {
          name: '报警记录',
          code: 'AlarmRecordChild'
        }, {
          name: '故障记录',
          code: 'FaultRecordChild'
        }
      ],
      pageType: 'DeviceGas',
      styleObject: {
        height: ''
      },
      styleObjectCons: {
        height: ''
      },
      tabData: {},
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 15,
        pageSizes: [15, 25, 35],
        total: 0
      },
      dataList: [],
      tableLoading: true,
      deviceChildId: null,
      consShow: false,
      currentTreeId: '',
      showChild: true,
      typeChild: '',
      devcieIdCode: ''
    }
  },
  created() {
    this.makeheight()
    this.makeheightCons()
    this.initData()
  },
  methods: {
    // 节点点击发生变化时，触发事件
    handleNodeSelect(item) {
      this.currentTreeId = item ? (item.value ? item.value : 0) : 0;
      this.pagination.currentPage = 1;
      this.initData();
    },
    serachData() {
      //查询//搜索
      this.searchText = this.searchText.replace(/(^\s*)|(\s*$)/g, "")
      this.pagination.currentPage = 1
      this.initData()
    },
    initData() {
      this.consShow = false
      this.params = {
        key: this.searchText,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        // install: this.keyWords.isInstall,
        alarm: this.keyWords.isAlarm,
        fault: this.keyWords.isFault,
        // regist: this.keyWords.isRegist,
        online: this.keyWords.isOnline,
        deviceId:this.deviceId
      }
      let type = this.type ?? 'gateway'
      this.request.get(`/front/device/${type}/child/page`, this.params)
        .then(res => {
          console.log(res)
          if (res.code === 200) {
            this.tableLoading = false
            this.consShow = true
            let data = res.data ? res.data : []
            // 处理复合烟感设备的温度数据去重，只保留 value 值大的那一项
            if (type === 'smokeands') {
              data = this.filterDuplicateTemperature(data)
            }
            this.dataList = data
            this.pagination.total = res.total
          } else if (res.code === 500) {
            this.dataList = []
            this.msg.warn(res.msg)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    jumpDev() {
      this.$emit('jumpDevice',false)
    },
    jumpDevChild(){
      this.tabData = {}
      this.initData()
    },
    toggleCom(tabCode) {
      // console.log(tabCode);
      this.tabData = tabCode
      this.component = tabCode.code
    },
    clickEven(val) {
      console.log(val);
      this.tabData = {
        name: '基本信息',
        code: 'BasicInfo'
      }
      this.deviceChildId = val.id
      this.typeChild = val.type
      this.devcieIdCode = val.code
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和makeheightCons
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    makeheightCons(height = 176) {
      let _this = this;
      _this.styleObjectCons.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObjectCons.height = window.innerHeight - height + "px";
        })();
      };
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.initData()
    },
    handleSizeChange(val) {
      this.pagination.currentPage = 1
      this.pagination.pageSize = val
      this.initData()
    },
    isInstallChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isRegistChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isOnlineChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isAlarmChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isFaultChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    filterDuplicateTemperature(dataList) {
      const temperatureItems = dataList.filter(item => item.type === '温度')
      const otherItems = dataList.filter(item => item.type !== '温度')
      
      if (temperatureItems.length > 1) {
        const maxTempItem = temperatureItems.reduce((prev, curr) => {
          return (prev.value > curr.value) ? prev : curr
        })
        return [...otherItems, maxTempItem]
      }
      return dataList
    },
    changeCards(val){
      if(val){
        let num = ''
        if (this.pagination.total > this.pagination.pageSize) {
          num = (this.pagination.total - this.dataList.length) % this.pagination.pageSize
          if (num == 0) {
            if(this.pagination.currentPage>1){
              this.pagination.currentPage = this.pagination.currentPage - 1                    
            }
          }
        }
        this.initData()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.GatewayChild {
  // position: relative;

  .navShow {
    margin-left: 20px;
    overflow: hidden;

    i {
      float: left;
      width: 16px;
      height: 16px;
      margin-right: 4px;

      img {
        width: 100%;
        height: 100%;
        vertical-align: unset;
      }
    }

    h3 {
      float: left;
      font-size: 16px;
      line-height: 16px;
      font-weight: 500;
      color: #7A7D81;
    }

    span {
      float: left;
      font-size: 16px;
      font-weight: 500;
      color: #7A7D81;
    }
  }

  .devcieContainer {
    margin: 20px 10px 10px 10px;
    // padding: 15px 20px;
    // background: #fff;
    box-sizing: border-box;
    overflow: auto;

    h4 {
      padding-bottom: 10px;
    }

    .container {
      padding: 0 10px 0 0px;
    }

    .query {
      padding-bottom: 10px;

      .queryCons {
        width: 100%;
        overflow: hidden;

        .common {
          float: left;
          margin-bottom: 5px;
          position: relative;
          .search{
            position: absolute;
            right: 10px;
            top: 0px;
            width: 40px;
            height: 40px;
            font-size: 0;
            z-index: 10;
            text-align: center;
            cursor: pointer;
            i{
              display: inline-block;
              width: 16px;
              height: 16px;
              cursor: pointer;
              margin-top: 12px;
              img{
                width: 100%;
                height: 100%;
              }
            }
          }
        }

        .primaryBtn {
          width: 82px;
          height: 40px;
          cursor: pointer;
          margin-right: 20px;
          font-size: 14px;
          line-height: 40px;
          border: 0;
          color: #FFFFFF;
          background: #1089FF;
          border-radius: 2px;

          &:hover {
            background: #0774e0;
          }
        }

        .delSome {
          width: 102px;
          cursor: pointer;
          float: right;
          font-size: 0;
          // line-height: 40px;
          // height: 40px;
          padding: 0 10px;
          border: 0;
          color: #FFFFFF;
          background: #1089FF;
          border-radius: 2px;
          outline: unset;
          overflow: hidden;

          &:hover {
            background: #0774e0;
          }

          .imgShow {
            float: left;
            width: 16px;
            height: 16px;
            margin: 10px 6px 0 0;

            img {
              width: 100%;
              height: 100%;
              vertical-align: middle;
            }

            &.active {
              transform: rotate(180deg);
            }
          }

          span {
            float: left;
            font-size: 14px;
            line-height: 40px;
          }
        }
      }
    }

    .listsContainer {
      overflow: hidden;
      position: relative;

      .listsLeft {
        float: left;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 0 0 60px;
        position: relative;

        // background: #f3f3f3;
        .noData {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -150px;
          margin-top: -150px;
          text-align: center;

          img {
            width: 300px;
            height: 300px;
          }

          .tip {
            margin-top: 10px;
            font-size: 18px;
            color: #bbb;
          }
        }

        .cardList {
          height: 100%;
          width: 100%;

          // overflow-x: hidden;
          // overflow-y: auto;
          &>li {
            float: left;
            width: 314px;
            height: 235px;
            padding: 10px;
            box-sizing: border-box;
          }
        }

        .cardPage {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 50px;
          text-align: center;
          padding: 10px 0;
          box-sizing: border-box;
        }

        &.active {
          width: 100%;

          .cardList {
            height: 100%;
            width: 100%;
            overflow-x: hidden;
            overflow-y: auto;

            &>li {
              float: left;
              width: 20%;
              height: 240px;
            }
          }
        }
      }

    }
  }
  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
  }

  @keyframes slid-open {
    0% {
      transform: translateX(100%);
      opacity: 0;
    }

    100% {
      transform: translateX(0);
    }
  }

  @keyframes slid-out {
    0% {
      width: 600px;
      transform: translateX(0)
    }

    100% {
      transform: translateX(100%)
    }
  }
}
</style><style lang="scss">
.GatewayChild {
  .devcieContainer {
    position: relative;
    .query {
      padding-left: 10px;

      .el-input {
        width: 260px;
        margin-right: 10px;
        .el-input__inner {
          line-height: 40px;
          height: 40px;
          border:none;
          outline: none;
        }
      }

      .el-select {
        width: 170px;
        margin-right: 10px;

        .el-input {
          width: 170px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 40px;
            height: 40px;
            border:none;
            outline: none;
          }
        }
      }
    }

    .el-loading-mask {
      background-color: unset;
    }
  }

  .el-breadcrumb {
    display: inline-block;
    padding: 0;
    font-family: AlibabaPuHuiTi-Medium;
    .deviceJump{
      cursor: pointer;
    }
    .deviceJumpChild{
      cursor: pointer;
    }
  }

  .el-breadcrumb__inner a,
  .el-breadcrumb__inner.is-link {
    color: #7A7D81;
    font-size: 16px;
    font-weight: 500;
  }

  .el-breadcrumb__separator {
    font-size: 16px;
    color: #7A7D81;
    margin: 0 5px;
    font-weight: 500;
  }

  .el-breadcrumb__inner {
    font-size: 16px;
    color: #7A7D81 !important;
    font-weight: 500 !important;
    line-height: 16px;
  }
}
</style>
